export default __webpack_public_path__ + "static/media/lithic_blade.55f6391d.png";